import { Navigate } from "react-router-dom";
import { useLocalizedHref } from "./use-localized-href";

type LocalizedNavigateProps = {
	to: string;
	replace?: boolean;
};

const LocalizedNavigate = ({ to, replace }: LocalizedNavigateProps) => {
	const localizedHref = useLocalizedHref();
	return <Navigate to={localizedHref(to)} replace={replace} />;
};

export { LocalizedNavigate };
